export const REMOVE_TEMPLATE_FROM_PRODUCT_MUTATION = `
mutation RemoveTemplateFromProduct($productId:ID!, $templateId:ID!) { 
\tremoveTemplateFromProduct(productId: $productId, templateId:$templateId)
}
`